export enum PriceType {
  base = 'base',
  extra = 'extra',
}
